// Hook pobierajacy pozycje konkretnej listy zakupowej klienta handlowca (tradera).
// GET /api/ui/sales-crm/clients/{clientId}/shopping-lists/{shoppingListId}/positions

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  IShoppingListPositionListItem
} from 'api/types';

export type IRequest = IPaginationRequest;
type IResponse = IPaginationResponse<IShoppingListPositionListItem>;

const getSalesCrmClientShoppingListPositions = (
  clientId: number,
  shoppingListId: number,
  params?: IRequest
): Promise<IResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/shopping-lists/${shoppingListId}/positions`, { params });

export const useGetSalesCrmClientShoppingListPositions = (
  clientId: number,
  shoppingListId: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['sales-crm-client-shopping-list-positions', clientId, shoppingListId, params],
    () => getSalesCrmClientShoppingListPositions(clientId, shoppingListId, params),
    options
  );
